// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/occupations_for_track.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Track } from "./track_pb.js";
import { TrackOccupation } from "./track_occupation_pb.js";

/**
 * @generated from message knop.ui.v1.model.OccupationsForTrack
 */
export class OccupationsForTrack extends Message<OccupationsForTrack> {
  /**
   * @generated from field: knop.ui.v1.model.Track track = 1;
   */
  track?: Track;

  /**
   * @generated from field: repeated knop.ui.v1.model.TrackOccupation occupations = 2;
   */
  occupations: TrackOccupation[] = [];

  constructor(data?: PartialMessage<OccupationsForTrack>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.OccupationsForTrack";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "track", kind: "message", T: Track },
    { no: 2, name: "occupations", kind: "message", T: TrackOccupation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OccupationsForTrack {
    return new OccupationsForTrack().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OccupationsForTrack {
    return new OccupationsForTrack().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OccupationsForTrack {
    return new OccupationsForTrack().fromJsonString(jsonString, options);
  }

  static equals(a: OccupationsForTrack | PlainMessage<OccupationsForTrack> | undefined, b: OccupationsForTrack | PlainMessage<OccupationsForTrack> | undefined): boolean {
    return proto3.util.equals(OccupationsForTrack, a, b);
  }
}

